// extracted by mini-css-extract-plugin
export default {"input":"Haa-z","button":"Iaa-z","selected":"Jaa-z","unavailable":"Kaa-z","oos":"Laa-z","image":"Maa-z","paperCutDisabledOverlay":"Naa-z"};